import { useState, createContext, FC, useMemo } from 'react';

type BreadcrumbAdditionalValueType = ReturnType<typeof BreadcrumbAdditionalValue>;

const BreadcrumbAdditionalValue = () => {
  const [additionalValue, setAdditionalValue] = useState<string | undefined>();
  // overrides the URL-derived header title; pages should clear it on unmount
  const [titleOverride, setTitleOverride] = useState<string | undefined>();
  // replaces the breadcrumbs under the title with plain text; pages should clear it on unmount
  const [subtitleOverride, setSubtitleOverride] = useState<string | undefined>();
  // rounds the header's corners to match card-style pages; pages should clear it on unmount
  const [roundedHeader, setRoundedHeader] = useState(false);

  return {
    additionalValue,
    setAdditionalValue,
    titleOverride,
    setTitleOverride,
    subtitleOverride,
    setSubtitleOverride,
    roundedHeader,
    setRoundedHeader,
  };
};

export const BreadcrumbContext = createContext<BreadcrumbAdditionalValueType>({} as BreadcrumbAdditionalValueType);

export const BreadcrumbProvider: FC = ({ children }) => {
  const value = BreadcrumbAdditionalValue();
  const memoizedValue = useMemo(() => value, [value]);
  return <BreadcrumbContext.Provider value={memoizedValue}>{children}</BreadcrumbContext.Provider>;
};
